/**
 * Created by matei on 2019-06-20
 */

import TermeniSiConditiiPage from './termeni-si-conditii';

export default TermeniSiConditiiPage;
